import { Box } from '@mui/material';
import headerImg from '@/assets/images/header.png';
import config from '@/config';
import React from 'react';

export const BackgroundErrorHeader = () => {
  const email = config.supportEmail;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
        borderBottom: '1px solid #ccc',
      }}
    >
      <Box
        sx={{
          height: { xs: '30px', sm: '50px' },
        }}
      >
        <img
          src={headerImg}
          alt="Header Image"
          style={{
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Box>
      <Box>
        <a href={`mailto:${email}`}>Contact Us</a>
      </Box>
    </Box>
  );
};
